/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Jgu7Inputs */

const en__field_enum_tuda_jgu7 = /** @type {(inputs: _Field_Enum_Tuda_Jgu7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Johannes Gutenberg-Universität Mainz`)
};

const de__field_enum_tuda_jgu7 = /** @type {(inputs: _Field_Enum_Tuda_Jgu7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Johannes Gutenberg-Universität Mainz`)
};

/**
* | output |
* | --- |
* | "Johannes Gutenberg-Universität Mainz" |
*
* @param {_Field_Enum_Tuda_Jgu7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_jgu7 = /** @type {((inputs?: _Field_Enum_Tuda_Jgu7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Jgu7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_jgu7(inputs)
	return de__field_enum_tuda_jgu7(inputs)
});
export { _field_enum_tuda_jgu7 as "_field_enum_TUDA_JGU" }